import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../utils.esm.js';

const EntityNamePickerFieldSchema = makeFieldSchemaFromZod(z.string());
const EntityNamePickerSchema = EntityNamePickerFieldSchema.schema;

export { EntityNamePickerSchema };
//# sourceMappingURL=schema.esm.js.map
